import React from 'react'
import styles from './AppBar.module.scss'

function AppBar({ isDashboard = false, completedOnBoarding = true, supportingText, title }) {
  return <div className={styles.innerWrapper}></div>
}

export default AppBar
